import IndicationOptionButton from 'components/common/button/IndicationOptionButton';
import CustomText from 'components/common/text/CustomText';
import { checkError } from 'lib/clinic/library';
import { indicationOptionList } from 'lib/clinic/mapper';
import {
  ICreateOptionValue,
  IOptionInfo,
  IOptionInfoValue,
  IOptionUi,
} from 'lib/types/clinic/projectTypes';
import { TValue } from 'lib/types/common';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

interface ProjectOptionRadioButtonProps {
  type: 'default' | 'advanced';
  optionValues: ICreateOptionValue;
  optionInfoList: IOptionInfo | null;
  onOptionChange: (type: 'default' | 'advanced', optionKey: string, value: TValue) => void;
}

const ProjectOptionRadioButton = ({
  type,
  optionValues,
  optionInfoList,
  onOptionChange,
}: ProjectOptionRadioButtonProps) => {
  // SECTION: declare hooks
  const { t } = useTranslation();

  return (
    <StyledProjectOptionRadioButton>
      {useMemo(
        () =>
          !!indicationOptionList.radio &&
          indicationOptionList.radio.map((option: IOptionUi) => {
            if (!optionInfoList) return;

            const { key: optionKey, title: optionLabel } = option;
            const optionValue = optionValues[optionKey]?.value;
            const optionInfo: IOptionInfoValue[] = optionInfoList[optionKey]?.values;

            if (checkError(optionValue) || !optionInfo) return;

            return (
              <div className="projectOption__item_box" key={option.key}>
                <div className="projectOption__title">
                  <CustomText fontSize={20} fontWeight={600} fontColor="#222">
                    {t(optionLabel)}
                  </CustomText>
                </div>
                <div className="projectOption__content">
                  {optionInfo?.map((option: IOptionInfoValue, index: number) => {
                    return (
                      <IndicationOptionButton
                        key={index}
                        className="form__text_check_btn"
                        value={option?.value || 0}
                        active={option?.value === optionValue}
                        onClick={(value: TValue) => {
                          onOptionChange(type, optionKey, value);
                        }}
                      >
                        {option?.description}
                      </IndicationOptionButton>
                    );
                  })}
                </div>
              </div>
            );
          }),
        [optionValues, optionInfoList],
      )}
    </StyledProjectOptionRadioButton>
  );
};

const StyledProjectOptionRadioButton = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 30px;
  .projectOption__item_box {
    display: flex;
    column-gap: 20px;
    .projectOption__title {
      width: 163px;
      display: flex;
      align-items: center;
      flex-shrink: 0;
    }
    .projectOption__content {
      width: 100%;
      display: flex;
    }
  }
`;

export default ProjectOptionRadioButton;
